import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { IExamStatsByQuestion } from "../../models/statistics.model";

interface IProps {
  data: IExamStatsByQuestion[]|undefined;
}

const ExamQuestionTable: FC<IProps> = ({
  data,
}) => {
  const { t } = useTranslation();
  return data?.length
    ? (
      <div className="comm-table__area rowType stats mt-0">
        <table>
          <tbody>
            <tr>
              <th>{t('statistics.placementTest.column8')}</th>
              <th>Indicator</th>
              <th>Skill</th>
              <th>{t('statistics.placementTest.column9')}</th>
              <th>{t('statistics.placementTest.column10')}</th>
              <th>{t('statistics.placementTest.column11')}</th>
            </tr>
            {data?.map((item, index) => (
              <>
                <tr>
                  <td rowSpan={item.skillInfo?.length}>{index + 1}</td>
                  <td rowSpan={item.skillInfo?.length}>
                    {item.indicatorKorName}<br />
                    {item.indicatorEngName}
                  </td>
                  {item.skillInfo?.slice(0,1).map(subitem => (
                    <>
                      <td>{subitem.skillName}</td>
                      <td>{subitem.correctAnswer}</td>
                      <td>{subitem.incorrectAnswer}</td>
                      <td>{subitem.correctAnswerRate}</td>
                    </>
                  ))}
                </tr>
                {item.skillInfo?.slice(1).map(subitem => (
                  <tr>
                    <td>{subitem.skillName}</td>
                    <td>{subitem.correctAnswer}</td>
                    <td>{subitem.incorrectAnswer}</td>
                    <td>{subitem.correctAnswerRate}</td>
                  </tr>
                ))}
              </>
            ))}
          </tbody>
        </table>
      </div>
      )
    : null
}

export default ExamQuestionTable;
